import React from 'react';
import { Form, Input, message } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { publicService } from '../../services/public.service';
import './LoginStype.css';

export const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const resetKey = searchParams.get('key');

  const submit = async (values: { newPassword: string }) => {
    if (!resetKey) {
      message.error('Đường dẫn đặt lại mật khẩu không hợp lệ');
      return;
    }
    try {
      await publicService.finishPasswordReset(resetKey, values.newPassword);
      await message.success('Đặt lại mật khẩu thành công');
      navigate('/login', { replace: true });
    } catch (error: any) {
      message.error(error?.message || 'Link đã hết hạn hoặc không hợp lệ');
    }
  };

  return (
    <div className="login-body" id="login-body">
      <img className="login-logo" src="/imgs/logo_full.png" alt="LinkPay" />
      <div className="otp-card">
        <h2 className="otp-title">Đặt lại mật khẩu</h2>
        {!resetKey ? (
          <>
            <div className="alert alert-danger">Đường dẫn không có mã xác thực.</div>
            <button type="button" className="clkbtn" onClick={() => navigate('/login')}>Về đăng nhập</button>
          </>
        ) : (
          <Form layout="vertical" onFinish={submit}>
            <Form.Item name="newPassword" label="Mật khẩu mới" rules={[
              { required: true, message: 'Vui lòng nhập mật khẩu mới' },
              { min: 4, max: 100, message: 'Mật khẩu phải có từ 4 đến 100 ký tự' },
            ]}>
              <Input.Password className="ele" autoComplete="new-password" />
            </Form.Item>
            <Form.Item name="confirmPassword" label="Xác nhận mật khẩu" dependencies={['newPassword']} rules={[
              { required: true, message: 'Vui lòng xác nhận mật khẩu' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  return !value || getFieldValue('newPassword') === value
                    ? Promise.resolve()
                    : Promise.reject(new Error('Mật khẩu xác nhận không khớp'));
                },
              }),
            ]}>
              <Input.Password className="ele" autoComplete="new-password" />
            </Form.Item>
            <button type="submit" className="clkbtn">Đổi mật khẩu</button>
          </Form>
        )}
      </div>
    </div>
  );
};
